import { Control, FieldErrors, UseFormWatch } from "react-hook-form"
import { TSale } from "../../core/types/Sale"
import { TCheckoutLayout } from "../../core/types/Checkout"
import CheckoutAddressDefault from "./Layouts/LayoutDefault/CheckoutAddressDefault"
import CheckoutAddress2 from "./Layouts/Layout2/CheckoutAddress2"
import React from "react"
import CheckoutAddress3 from "./Layouts/Layout3/CheckoutAddress3"
import CheckoutAddress4 from "./Layouts/Layout4/CheckoutAddress4"
import CheckoutAddress5 from "./Layouts/Layout5/CheckoutAddress5"
import CheckoutAddress6 from "./Layouts/Layout6/CheckoutAddress6"
import CheckoutAddress7 from "./Layouts/Layout7/CheckoutAddress7"
import CheckoutAddress8 from "./Layouts/Layout8/CheckoutAddress8"

interface ICheckoutAddress {
  layout?: TCheckoutLayout
  hideCheckoutAddress?: boolean
  control: Control<TSale, any>
  errors: FieldErrors<TSale>
  loading: boolean
  searchedZipCode: boolean
  watch: UseFormWatch<TSale>
  saveLostSale: () => void
  clearErrors: () => void
  searchZipCode: (loading: boolean, zipCode: string) => void
  handleAddresNumberKeyDown: (e: React.KeyboardEvent<HTMLDivElement>) => void
  handleAddresComplementKeyDown: (
    e: React.KeyboardEvent<HTMLDivElement>
  ) => void
  onSendPixel: () => void
}

const CheckoutAddress = ({
  layout,
  hideCheckoutAddress,
  control,
  errors,
  loading,
  searchedZipCode,
  watch,
  saveLostSale,
  clearErrors,
  searchZipCode,
  handleAddresNumberKeyDown,
  handleAddresComplementKeyDown,
  onSendPixel,
}: ICheckoutAddress) => {
  if (hideCheckoutAddress === true || !layout) {
    return <></>
  }

  const checkoutAddressData = {
    [TCheckoutLayout.Default]: (
      <CheckoutAddressDefault
        control={control}
        errors={errors}
        loading={loading}
        searchedZipCode={searchedZipCode}
        watch={watch}
        saveLostSale={saveLostSale}
        clearErrors={clearErrors}
        searchZipCode={searchZipCode}
        handleAddresNumberKeyDown={handleAddresNumberKeyDown}
        handleAddresComplementKeyDown={handleAddresComplementKeyDown}
      />
    ),
    [TCheckoutLayout.Layout2]: (
      <CheckoutAddress2
        control={control}
        errors={errors}
        loading={loading}
        searchedZipCode={searchedZipCode}
        watch={watch}
        saveLostSale={saveLostSale}
        clearErrors={clearErrors}
        searchZipCode={searchZipCode}
        handleAddresNumberKeyDown={handleAddresNumberKeyDown}
        handleAddresComplementKeyDown={handleAddresComplementKeyDown}
      />
    ),
    [TCheckoutLayout.Layout3]: (
      <CheckoutAddress3
        control={control}
        errors={errors}
        loading={loading}
        searchedZipCode={searchedZipCode}
        watch={watch}
        saveLostSale={saveLostSale}
        clearErrors={clearErrors}
        searchZipCode={searchZipCode}
        handleAddresNumberKeyDown={handleAddresNumberKeyDown}
        handleAddresComplementKeyDown={handleAddresComplementKeyDown}
        onSendPixel={onSendPixel}
      />
    ),
    [TCheckoutLayout.Layout4]: (
      <CheckoutAddress4
        control={control}
        errors={errors}
        loading={loading}
        searchedZipCode={searchedZipCode}
        watch={watch}
        saveLostSale={saveLostSale}
        clearErrors={clearErrors}
        searchZipCode={searchZipCode}
        handleAddresNumberKeyDown={handleAddresNumberKeyDown}
        handleAddresComplementKeyDown={handleAddresComplementKeyDown}
        onSendPixel={onSendPixel}
      />
    ),
    [TCheckoutLayout.Layout5]: (
      <CheckoutAddress5
        control={control}
        errors={errors}
        loading={loading}
        searchedZipCode={searchedZipCode}
        watch={watch}
        saveLostSale={saveLostSale}
        clearErrors={clearErrors}
        searchZipCode={searchZipCode}
        handleAddresNumberKeyDown={handleAddresNumberKeyDown}
        handleAddresComplementKeyDown={handleAddresComplementKeyDown}
        onSendPixel={onSendPixel}
      />
    ),
    [TCheckoutLayout.Layout6]: (
      <CheckoutAddress6
        control={control}
        errors={errors}
        loading={loading}
        searchedZipCode={searchedZipCode}
        watch={watch}
        saveLostSale={saveLostSale}
        clearErrors={clearErrors}
        searchZipCode={searchZipCode}
        handleAddresNumberKeyDown={handleAddresNumberKeyDown}
        handleAddresComplementKeyDown={handleAddresComplementKeyDown}
        onSendPixel={onSendPixel}
      />
    ),
    [TCheckoutLayout.Layout7]: (
      <CheckoutAddress7
        control={control}
        errors={errors}
        loading={loading}
        searchedZipCode={searchedZipCode}
        watch={watch}
        saveLostSale={saveLostSale}
        clearErrors={clearErrors}
        searchZipCode={searchZipCode}
        handleAddresNumberKeyDown={handleAddresNumberKeyDown}
        handleAddresComplementKeyDown={handleAddresComplementKeyDown}
        onSendPixel={onSendPixel}
      />
    ),
    [TCheckoutLayout.Layout8]: (
      <CheckoutAddress8
        control={control}
        errors={errors}
        loading={loading}
        searchedZipCode={searchedZipCode}
        watch={watch}
        saveLostSale={saveLostSale}
        clearErrors={clearErrors}
        searchZipCode={searchZipCode}
        handleAddresNumberKeyDown={handleAddresNumberKeyDown}
        handleAddresComplementKeyDown={handleAddresComplementKeyDown}
        onSendPixel={onSendPixel}
      />
    ),
  }

  return checkoutAddressData[layout] || <></>
}

export default CheckoutAddress
